import React from 'react'
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell } from 'semantic-ui-react'
import { filterOrdersByDate, getRevenue, getCost, numberWithCommas } from './utils'

const OrdersTable = ({ orders }) => {
    const timeFrames = [
        { label: 'Lifetime', hours: 1000000, bold: true },
        { label: 'Past 7 Days', hours: 168 },
        { label: 'Past 24 Hours', hours: 24 },
        { label: 'Past 8 Hours', hours: 8 },
    ]

    return (
        <Table size={window.innerWidth < 768 ? 'small' : null} celled unstackable inverted style={window.innerWidth < 768 ? { overflowX: 'auto', display: 'block', whiteSpace: 'nowrap', marginTop: 20 } : { marginTop: 20 }}>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell width={3}></TableHeaderCell>
                    <TableHeaderCell>Orders</TableHeaderCell>
                    <TableHeaderCell>Average Order</TableHeaderCell>
                    <TableHeaderCell>Revenue</TableHeaderCell>
                    <TableHeaderCell>Cost</TableHeaderCell>
                    <TableHeaderCell>Profit</TableHeaderCell>
                    <TableHeaderCell>Margin</TableHeaderCell>
                </TableRow>
            </TableHeader>
            <TableBody>
                {timeFrames.map(({ label, hours, bold }) => {
                    const filteredOrders = filterOrdersByDate(orders, hours)
                    const revenue = getRevenue(filteredOrders)
                    const cost = getCost(filteredOrders)
                    const profit = revenue - cost
                    const CellComponent = bold ? 'b' : React.Fragment

                    return (
                        <TableRow key={label}>
                            <TableCell><h4 style={{ color: 'white' }}>{label}</h4></TableCell>
                            <TableCell><CellComponent>{numberWithCommas(filteredOrders.length)}</CellComponent></TableCell>
                            <TableCell><CellComponent>${((revenue / filteredOrders.length) || 0).toFixed(2)}</CellComponent></TableCell>
                            <TableCell style={{ color: '#90EE90' }}><CellComponent>${numberWithCommas(revenue.toFixed(2))}</CellComponent></TableCell>
                            <TableCell style={{ color: '#FAA0A0' }}><CellComponent>${numberWithCommas(cost.toFixed(2))}</CellComponent></TableCell>
                            <TableCell style={{ color: '#90EE90' }}><CellComponent>${numberWithCommas(profit.toFixed(2))}</CellComponent></TableCell>
                            <TableCell style={{ color: '#90EE90' }}><CellComponent>{((profit / revenue * 100) || 0).toFixed(2)}%</CellComponent></TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}

export default OrdersTable